import { Box, Typography, useTheme } from "@mui/material";
import { ReactComponent as CaretUpSolidIcon } from "../../../assets/faIcons/caret-up-solid.svg";
import CircleIcon from "@mui/icons-material/Circle";
import MuiSVGIcon from "../../../components/IconPicker/MuiSVGIcon";
import SquareIcon from "@mui/icons-material/Square";

function MapViewLegend() {
  const theme = useTheme();
  const { palette = {} } = theme;
  const { primary = {}, success = {}, mode } = palette;
  const isDark = mode === "dark";
  const navyColor = primary?.main || "#002843";
  const greenColor = success?.main || "#A0C46D";
  const textColor = isDark ? "rgba(255,255,255,0.9)" : "rgba(0,0,0,0.75)";

  const itemSx = {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.75,
    padding: "4px 10px",
    borderRadius: "8px",
    backgroundColor: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
    marginRight: 1,
    marginBottom: 0.75,
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.06)",
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 0,
        color: textColor,
        fontWeight: 500,
        fontSize: "0.875rem",
      }}
    >
      <Box sx={itemSx}>
        <Typography component="span" sx={{ fontSize: "inherit", fontWeight: 600 }}>
          Assets:
        </Typography>
        <MuiSVGIcon
          icon={<CaretUpSolidIcon />}
          sx={{ color: greenColor, fontSize: "1.25rem" }}
        />
      </Box>
      <Box sx={itemSx}>
        <Typography component="span" sx={{ fontSize: "inherit", fontWeight: 600 }}>
          Radios:
        </Typography>
        <SquareIcon sx={{ color: isDark ? "#e2e8f0" : "#334155", fontSize: "1.25rem" }} />
      </Box>
      <Box sx={itemSx}>
        <Typography component="span" sx={{ fontSize: "inherit", fontWeight: 600 }}>
          Target Zones:
        </Typography>
        <CircleIcon sx={{ color: "#947447", fontSize: "1rem" }} />
      </Box>
      <Box sx={itemSx}>
        <Typography component="span" sx={{ fontSize: "inherit", fontWeight: 600 }}>
          Processing Zones:
        </Typography>
        <CircleIcon sx={{ color: "#ef4444", fontSize: "1rem" }} />
      </Box>
      <Box sx={itemSx}>
        <Typography component="span" sx={{ fontSize: "inherit", fontWeight: 600 }}>
          Processing (highlighted):
        </Typography>
        <CircleIcon sx={{ color: "#a855f7", fontSize: "1rem" }} />
      </Box>
      <Box sx={itemSx}>
        <Typography component="span" sx={{ fontSize: "inherit", fontWeight: 600 }}>
          Target (highlighted):
        </Typography>
        <CircleIcon sx={{ color: "#03f8fc", fontSize: "1rem" }} />
      </Box>
    </Box>
  );
}

export default MapViewLegend;
